/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable func-names */
/* eslint-disable no-unused-vars */
/* eslint-disable camelcase */
import React, {
  Suspense,
  useContext,
  useEffect,
  useState,
  useCallback,
} from 'react';
// import logo from './logo.svg';
import './App.css';
import {
  Routes,
  Route,
  useLocation,
  useNavigate,
  Navigate,
} from 'react-router-dom';

import { useDispatch } from 'react-redux';
import { UseMutationResult } from 'react-query';
import { AxiosError, AxiosResponse } from 'axios';
import { Helmet } from 'react-helmet';
import posthog from 'posthog-js';
import { Onecardweb } from './Components/OneOptimisticRedirecter';
import { InitScreen } from './Components/features/InitialScreen/InitScreen';
import ErrorBoundary from './error/errorBoundary';
import { CommonError } from './Components/features/CommonError/CommonError';
import { CommonLoader } from './Components/Common/CommonLoader';
import { ExperianMaxTries } from './Components/features/Experian/ExperianMaxTries';
import { OfferExpired } from './Components/features/OfferStatus/OfferExpired';
import { Iutmheaders } from './Components/features/ContactNumber/MobileNumber';
import { setEncryptedInfo } from './encryptedDetailsSlice';
import { logoutUser } from './api/logout';
import { useBffApi } from './hooks/useBffApi';
import { useAppSelector } from './app/hooks';
import { RootState } from './app/store';
import { number } from './Components/features/ContactNumber/mobileSlice';
import {
  setAuthzInfo,
  setCustomerNumber,
} from './Components/features/OtpValidation/authzSlice';
import { ProtectiontoAllRoute } from './app/ProtectiontoAllRoute';
import { ProtectPhoneOTPScreen } from './app/ProtectedRoutes';
import {
  CustomePopups,
  PopupContext,
} from './Components/Common/Custompopups';
import { MODAL } from './Components/Common/ConstantStrings';
import { ApplicationSteps } from './Components/Common/ApplicationSteps';
import {
  setBankImageLink,
  setEmployCode,
} from './bankLogoEmployCodeSlice';
import bobImg from './images/boblogo.jpg';
import allBanksWeb from './images/banksLogosNew.png';

interface bankingPartnersLogoType {
  csb: string;
  bob: string;
  sbm: string;
  sib: string;
  idfc: string;
  fed: string;
}

const Prebook = React.lazy(() =>
  import('./Components/features/OfferStatus/Prebook').then(
    (module) => ({
      default: module.Prebook,
    }),
  ),
);

const CibilMaxTries = React.lazy(() =>
  import('./Components/features/Cibil/CibilMaxTries').then(
    (module) => ({
      default: module.CibilMaxTries,
    }),
  ),
);

const PaninProgress = React.lazy(() =>
  import('./Components/features/OfferStatus/Panvalidation').then(
    (module) => ({
      default: module.Panvalidation,
    }),
  ),
);

const AddressInProgress = React.lazy(() =>
  import('./Components/features/AddressDetails/AddressPending').then(
    (module) => ({
      default: module.AddressPending,
    }),
  ),
);

const ExperianError = React.lazy(() =>
  import('./Components/features/Experian/ExperianError').then(
    (module) => ({
      default: module.ExperianError,
    }),
  ),
);

const ExistingCustomer = React.lazy(() =>
  import('./Components/features/OfferStatus/ExistingCustomer').then(
    (module) => ({
      default: module.ExistingCustomer,
    }),
  ),
);
const AdharNotLinked = React.lazy(() =>
  import('./Components/features/OfferStatus/AdharPanNotMap').then(
    (module) => ({
      default: module.default,
    }),
  ),
);

const Panvalidation = React.lazy(() =>
  import('./Components/features/OfferStatus/Panvalidation').then(
    (module) => ({
      default: module.Panvalidation,
    }),
  ),
);

const ExperianFetching = React.lazy(() =>
  import('./Components/features/Experian/ExperianFetching').then(
    (module) => ({
      default: module.ExperianFetching,
    }),
  ),
);

const CibilKbaAuthFail = React.lazy(() =>
  import(
    './Components/features/Cibil/CibilErrors/CibilKbaAuthFail'
  ).then((module) => ({
    default: module.CibilKbaAuthFail,
  })),
);
const LocationUnServiceable = React.lazy(() =>
  import(
    './Components/features/OfferStatus/LocationUnServiceable'
  ).then((module) => ({
    default: module.LocationUnServiceable,
  })),
);

const CibilOtp = React.lazy(() =>
  import('./Components/features/Cibil/CibilOtp').then((module) => ({
    default: module.CibilOtp,
  })),
);

const WaitList = React.lazy(() =>
  import('./Components/features/OfferStatus/WaitList').then(
    (module) => ({
      default: module.WaitList,
    }),
  ),
);

const MobileNumber = React.lazy(() =>
  import('./Components/features/ContactNumber/MobileNumber').then(
    (module) => ({ default: module.MobileNumber }),
  ),
);
const LandingPage = React.lazy(() =>
  import('./Components/features/NewLandingPage/NewLandingPage').then(
    (module) => ({ default: module.NewLandingPage }),
  ),
);
const Otp = React.lazy(() =>
  import('./Components/features/OtpValidation/Otp').then(
    (module) => ({ default: module.Otp }),
  ),
);

const PersonalDetail = React.lazy(() =>
  import('./Components/features/PersonalDetails/PersonalDetail').then(
    (module) => ({ default: module.PersonalDetail }),
  ),
);

const AddressDetail = React.lazy(() =>
  import('./Components/features/AddressDetails/AddressDetail').then(
    (module) => ({ default: module.AddressDetail }),
  ),
);
const AddressSuccess = React.lazy(() =>
  import('./Components/features/AddressDetails/AddressSuccess').then(
    (module) => ({ default: module.AddressSuccess }),
  ),
);

const Email = React.lazy(() =>
  import('./Components/features/Email/Email').then((module) => ({
    default: module.Email,
  })),
);
const OfferReserve = React.lazy(() =>
  import('./Components/features/OfferStatus/OfferReserve').then(
    (module) => ({
      default: module.default,
    }),
  ),
);
const ApplicationDeclined = React.lazy(() =>
  import(
    './Components/features/OfferStatus/ApplicationDeclined'
  ).then((module) => ({
    default: module.ApplicationDeclined,
  })),
);

// const FinalOffer = React.lazy(() =>
//   import('./Components/features/OfferStatus/FinalOffer').then(
//     (module) => ({
//       default: module.FinalOffer,
//     }),
//   ),
// );

const SecureOrUnsecure = React.lazy(() =>
  import('./Components/features/OfferStatus/SecureOrUnsecure').then(
    (module) => ({
      default: module.SecureOrUnsecure,
    }),
  ),
);

const Kba = React.lazy(() =>
  import('./Components/features/Cibil/Kba').then((module) => ({
    default: module.Kba,
  })),
);

const CibilFetching = React.lazy(() =>
  import('./Components/features/Cibil/CibilFetching').then(
    (module) => ({
      default: module.CibilFetching,
    }),
  ),
);

const CibilServerError = React.lazy(() =>
  import('./Components/features/Cibil/CibilErrors/ServerFail').then(
    (module) => ({
      default: module.ServerFail,
    }),
  ),
);

const CibilAuthStatus = React.lazy(() =>
  import('./Components/features/Cibil/CibilErrors/CibilAuth').then(
    (module) => ({
      default: module.CibilAuth,
    }),
  ),
);

const ApplicationStatusPoller = React.lazy(() =>
  import('./Components/features/applicationStatusPoller').then(
    (module) => ({
      default: module.ApplicationStatusPoller,
    }),
  ),
);

const Termsandcondition = React.lazy(() =>
  import(
    './Components/features/TermsAndCondition/Termsandcondition'
  ).then((module) => ({ default: module.Termsandcondition })),
);

const BankofBarodha = React.lazy(() =>
  import('./Components/Banks/BankofBarodha').then((module) => ({
    default: module.BankofBarodha,
  })),
);

export const App = CustomePopups(() => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const popupContext = useContext(PopupContext);
  const authzToken = useAppSelector(
    (state: RootState) => state.authz.AuthzInfo,
  );
  const [utmHeaders, setutmHeaders] = useState<Iutmheaders>({
    utm_campaign: '',
    utm_medium: '',
    utm_id: '',
    utm_source: '',
    utm_term: '',
    utm_content: '',
  });
  useEffect(() => {
    posthog.capture('$pageview');
    // eslint-disable-next-line no-console
    console.log('posthog pageview changed to ', location);
    // eslint-disable-next-line no-console
    console.log(
      'api is',
      process.env.REACT_APP_API_URL,
      'and the x-api key is ',
      process.env.REACT_APP_X_API_KEY,
    );
  }, [location]);
  // const [selectedBank, setSelectedBank] = useState('');

  // const bankingPartnersLogo: bankingPartnersLogoType = {
  //   csb: 'https://getonecard.app/images/legal/CSB_Bank_PNG_Logo.png',
  //   bob: bobImg,
  //   fed: 'https://www.getonecard.app/images/legal/federal_bank_logo.png',
  //   sib: 'https://www.getonecard.app/images/legal/sib_logo.png',
  //   sbm: 'https://www.getonecard.app/assets/icons/sbm_bank_logo.png',
  //   idfc: 'https://www.getonecard.app/assets/icons/idfc_first_logo.png',
  // };

  // useEffect(() => {
  //   (() => {
  //     let result = '';
  //     let empCode = '';
  //     const searchingValue = utmHeaders.utm_source;
  //     if (searchingValue) {
  //       // eslint-disable-next-line
  //       for (const key in bankingPartnersLogo) {
  //         if (searchingValue.toLowerCase().includes(key)) {
  //           result =
  //             bankingPartnersLogo[
  //               key as keyof bankingPartnersLogoType
  //             ];
  //           break;
  //         }
  //       }
  //     }
  //     dispatch(setBankImageLink(result));
  //     if (utmHeaders.utm_content) {
  //       const searchingValue = utmHeaders.utm_content.split('_');
  //       const index = searchingValue.length - 1;
  //       empCode = searchingValue[index];
  //     }
  //     dispatch(setEmployCode(empCode));
  //   })();
  // }, [utmHeaders]);

  const selectedBank = useAppSelector(
    (state: RootState) => state.bankDetails.bankImageLink,
  );

  // const bankingPartnerImgLink = useCallback(() => {
  //   let result = '';
  //   console.log(utmHeaders.utm_source, 'utm_sources');

  //   if (utmHeaders.utm_source) {
  //     const searchingValue = utmHeaders.utm_source;
  //     // eslint-disable-next-line
  //     for (const key in bankingPartnersLogo) {
  //       if (searchingValue.toLowerCase().includes(key)) {
  //         result =
  //           bankingPartnersLogo[key as keyof bankingPartnersLogoType];
  //         break;
  //       }
  //     }
  //   }

  //   return result;
  // }, []);
  const para = new URLSearchParams(location.search);
  useEffect(() => {
    if (para.get('start-page') === 'app') {
      if (para.get('dataAttribute') && para.get('partner_name')) {
        dispatch(
          setEncryptedInfo({
            encryptedData:
              encodeURIComponent(
                para.get('dataAttribute') as string,
              ) ?? '',
            partnerName: para.get('partner_name') ?? '',
          }),
        );
      }
      navigate('onecardweb/phone');
    }
    let temp = { ...utmHeaders };
    Object.keys(utmHeaders).forEach((elem) => {
      if (para.get(elem) !== null) {
        temp = { ...temp, [elem]: para.get(elem) };
      }
    });
    setutmHeaders(temp);
  }, []);

  const { mutate } = useBffApi<
    string,
    Function,
    UseMutationResult<AxiosResponse<any>, AxiosError>
  >(logoutUser);

  // const logoutEventHandle = () => {
  //   mutate(
  //     { authz: authzToken },
  //     {
  //       onSuccess: async (response) => {
  //         navigate('onecardweb/phone');
  //         dispatch(number(''));
  //         dispatch(setAuthzInfo(''));
  //         dispatch(setCustomerNumber(''));
  //       },
  //       onError: async (err) => {
  //         if (err.response?.status === 401) {
  //           popupContext.showPopup(
  //             'Session Expired Please Login!',
  //             MODAL,
  //           );
  //         }
  //       },
  //     },
  //   );
  // };

  // eslint-disable-next-line no-console

  return (
    <div
      className={
        location.pathname === '/onecardweb/signUp '
          ? 'bg-black mobile:mr-0 box font-Manrope min-h-screen flex flex-col justify-between'
          : 'bg-customedarkblue-400 font-Manrope min-h-screen flex flex-col justify-between'
      }
    >
      <Helmet>
        <title>OneCard</title>
        <meta
          name="description"
          content="OneCard - Best Metal Credit Card"
        />
      </Helmet>
      <div
        className={
          location.pathname === '/onecardweb/signUp'
            ? `text-white min-h-screen  box-border font-Manrope bg-blue bg-fixed bg-cover`
            : `text-white min-h-screen  box-border font-Manrope bg-bgpattern bg-fixed bg-cover`
        }
      >
        {location.pathname === '/onecardweb/signUp' ? (
          <div className="flex items-center flex-wrap pl-36 ml-20 mobile:justify-center mobile:ml-0 mobile:pl-0 tablet:ml-0 tablet:pl-10">
            <img
              alt="onecard"
              className="md:h-16 md:w-16 h-12 w-12"
              src="https://www.getonecard.app/images/One_logo_white_59by336.svg"
            />
          </div>
        ) : (
          <div className="flex items-center flex-wrap">
            <div
              className={`${
                location.pathname === '/' ? ' hidden ' : ' flex '
              } onecadlogo md:flex  flex-row items-end md:pb-6 pb-4  justify-center md:w-20 md:h-32  w-16 h-20 rounded-bl-3xl rounded-br-3xl ml-10 sm:ml-20 bg-gray-200 bg-opacity-5 blur-xl`}
            >
              <img
                alt="onecard"
                className="md:h-16 md:w-16 h-10 w-10"
                src="https://www.getonecard.app/images/One_logo_white_59by336.svg"
              />
            </div>

            {location.pathname !== '/' &&
            location.pathname !== '/onecardweb/adharPan-unlinked' &&
            location.pathname !==
              '/onecardweb/offer-details-reserve' &&
            location.pathname !== '/onecardweb/signUp' ? (
              <ApplicationSteps />
            ) : (
              ''
            )}
          </div>
        )}
        {location.pathname !== '/' &&
        location.pathname !== '/onecardweb/signUp' &&
        selectedBank ? (
          <div className="absolute w-28 h-14 right-10 top-5 lg:top-banklogoTop lg:right-20 lg:w-36 ">
            <img
              src={selectedBank} //eslint-disable-line
              alt="banking partner"
              className="w-full"
            />
          </div>
        ) : null}
        <Routes>
          <Route path="/" element={<InitScreen />} />
          <Route
            path="/bank-of-baroda-onecard-credit-card"
            element={
              <Suspense fallback={<CommonLoader />}>
                <BankofBarodha {...utmHeaders} />
              </Suspense>
            }
          />
          <Route element={<ProtectPhoneOTPScreen />}>
            <Route
              path="/onecardweb/phone"
              element={
                <Suspense fallback={<CommonLoader />}>
                  <MobileNumber utmHeaders={utmHeaders} />
                </Suspense>
              }
            />
            <Route
              path="/onecardweb/signUp"
              element={
                <Suspense fallback={<CommonLoader />}>
                  <LandingPage utmHeaders={utmHeaders} />
                </Suspense>
              }
            />
            <Route
              path="onecardweb/phone-otp-confirmation"
              element={
                <Suspense fallback={<CommonLoader />}>
                  <Otp utmHeaders={utmHeaders} />
                </Suspense>
              }
            />
          </Route>
          <Route element={<ProtectiontoAllRoute />}>
            <Route
              path="onecardweb/personal-details"
              element={
                <Suspense fallback={<CommonLoader />}>
                  <PersonalDetail />
                </Suspense>
              }
            />
            <Route
              path="onecardweb/address-details"
              element={
                <Suspense fallback={<CommonLoader />}>
                  <AddressDetail />
                </Suspense>
              }
            />
            <Route
              path="onecardweb/adharPan-unlinked"
              element={
                <Suspense fallback={<CommonLoader />}>
                  <AdharNotLinked />
                </Suspense>
              }
            />
            <Route
              path="onecardweb/email-confirmation"
              element={
                <Suspense fallback={<CommonLoader />}>
                  <Email />
                </Suspense>
              }
            />
            <Route
              path="onecardweb/offer-details"
              element={
                <Suspense fallback={<CommonLoader />}>
                  <SecureOrUnsecure />
                </Suspense>
              }
            />
            <Route
              path="onecardweb/offer-details-reserve"
              element={
                <Suspense fallback={<CommonLoader />}>
                  <OfferReserve />
                </Suspense>
              }
            />
            <Route
              path="onecardweb/offer-details/terms-and-condition"
              element={
                <Suspense fallback={<CommonLoader />}>
                  <Termsandcondition />
                </Suspense>
              }
            />

            <Route
              path="onecardweb/offer-expired"
              element={
                <Suspense fallback={<CommonLoader />}>
                  <OfferExpired />
                </Suspense>
              }
            />
            <Route path="onecardweb" element={<Onecardweb />} />
            <Route
              path="onecardweb/declined"
              element={
                <Suspense fallback={<CommonLoader />}>
                  <ApplicationDeclined />
                </Suspense>
              }
            />
            <Route
              path="onecardweb/cibil"
              element={
                <Suspense fallback={<CommonLoader />}>
                  <CibilFetching />
                </Suspense>
              }
            />
            <Route
              path="onecardweb/cibil/otp"
              element={
                <Suspense fallback={<CommonLoader />}>
                  <CibilOtp />
                </Suspense>
              }
            />
            <Route
              path="onecardweb/underwriting/server-down"
              element={
                <Suspense fallback={<CommonLoader />}>
                  <CibilServerError />
                </Suspense>
              }
            />
            <Route
              path="onecardweb/cibil/status"
              element={
                <Suspense fallback={<CommonLoader />}>
                  <CibilAuthStatus />
                </Suspense>
              }
            />
            <Route
              path="onecardweb/cibil/kba"
              element={
                <Suspense fallback={<CommonLoader />}>
                  <ErrorBoundary>
                    <Kba />
                  </ErrorBoundary>
                </Suspense>
              }
            />
            <Route
              path="onecardweb/status"
              element={
                <Suspense fallback={<CommonLoader />}>
                  <ApplicationStatusPoller />
                </Suspense>
              }
            />
            <Route
              path="onecardweb/cibil/kba-fail"
              element={
                <Suspense fallback={<CommonLoader />}>
                  <CibilKbaAuthFail />
                </Suspense>
              }
            />
            <Route
              path="onecardweb/cibil/max-attempts"
              element={
                <Suspense fallback={<CommonLoader />}>
                  <CibilMaxTries />
                </Suspense>
              }
            />
            <Route
              path="onecardweb/unserviceable"
              element={
                <Suspense fallback={<CommonLoader />}>
                  <LocationUnServiceable />
                </Suspense>
              }
            />
            <Route
              path="onecardweb/pre-book"
              element={
                <Suspense fallback={<CommonLoader />}>
                  <Prebook />
                </Suspense>
              }
            />
            <Route
              path="onecardweb/waitlist"
              element={
                <Suspense fallback={<CommonLoader />}>
                  <WaitList />
                </Suspense>
              }
            />
            <Route
              path="onecardweb/error"
              element={
                <Suspense fallback={<CommonLoader />}>
                  <CommonError />
                </Suspense>
              }
            />
            <Route
              path="onecardweb/experian"
              element={
                <Suspense fallback={<CommonLoader />}>
                  <ExperianFetching />
                </Suspense>
              }
            />
            <Route
              path="onecardweb/experian/max-attempts"
              element={
                <Suspense fallback={<CommonLoader />}>
                  <ExperianMaxTries />
                </Suspense>
              }
            />
            <Route
              path="onecardweb/experian/error"
              element={
                <Suspense fallback={<CommonLoader />}>
                  <ExperianError />
                </Suspense>
              }
            />
            <Route
              path="onecardweb/existing-customer"
              element={
                <Suspense fallback={<CommonLoader />}>
                  <ExistingCustomer />
                </Suspense>
              }
            />
            <Route
              path="onecardweb/pan-inprogress"
              element={
                <Suspense fallback={<CommonLoader />}>
                  <PaninProgress />
                </Suspense>
              }
            />
            <Route
              path="onecardweb/address-inprogress"
              element={
                <Suspense fallback={<CommonLoader />}>
                  <AddressInProgress />
                </Suspense>
              }
            />
            <Route
              path="onecardweb/pan-validation/status"
              element={
                <Suspense fallback={<CommonLoader />}>
                  <Panvalidation />
                </Suspense>
              }
            />
            <Route
              path="onecardweb/address-success"
              element={
                <Suspense fallback={<CommonLoader />}>
                  <AddressSuccess />
                </Suspense>
              }
            />
            <Route
              path="onecardweb/offerExpired"
              element={
                <Suspense fallback={<CommonLoader />}>
                  lC
                  <OfferExpired />
                </Suspense>
              }
            />
          </Route>
        </Routes>
        {/* Conditionally render the last div only if not on InitScreen, because the following code is already there in initscreen */}
        {location.pathname !== '/' && (
          <div className="mt-24 ml-20 flex flex-col  text-white">
            <p className="text-lg">Co-Branded Card Issuers:</p>
            <div className="flex mb-5 sm:mb-0">
              <img
                src={allBanksWeb}
                alt="banking partners"
                className="w-60"
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
});
